import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ApButtonComponent } from '@ap/button';
import { ApFormControlPipe } from '@ap/cdk';
import { ApContentPipe } from '@ap/content';
import { ApFormErrorsComponent } from '@ap/form/errors';
import { ApInlineSvgDirective } from '@ap/inline-svg';
import { ApTextareaComponent } from '@ap/textarea';

import { FeedbackFormComponent } from './form.component';

/**
 * @ngdoc module
 * @name FeedbackFormModule
 **/
@NgModule({
    imports: [
        ApButtonComponent,
        ApFormControlPipe,
        ApContentPipe,
        ApFormErrorsComponent,
        ApTextareaComponent,
        CommonModule,
        FormsModule,
        ApInlineSvgDirective,
        ReactiveFormsModule
    ],
    exports: [FeedbackFormComponent],
    declarations: [FeedbackFormComponent]
})
export class FeedbackFormModule {}
